import { Breadcrumbs, SxProps, Theme, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export interface IBreadcrumbItem {
    label: string;
    href?: string;
}

interface IIotVisionBreadcrumbsProps {
    items: IBreadcrumbItem[];
    ariaLabel?: string;
    sx?: SxProps<Theme>;
}

const IotVisionBreadcrumbs = ({ items, ariaLabel = "breadcrumb", sx }: IIotVisionBreadcrumbsProps): JSX.Element => (
    <Breadcrumbs aria-label={ariaLabel} sx={sx}>
        {items.map(({ label, href }, index) => {
            const isLast = index === items.length - 1;
            if (href && !isLast) {
                return (
                    <Link key={label} to={href} style={{ textDecoration: "none" }}>
                        <Typography color="text.secondary">{label}</Typography>
                    </Link>
                );
            }
            return (
                <Typography key={label} color={isLast ? "text.primary" : "text.secondary"}>
                    {label}
                </Typography>
            );
        })}
    </Breadcrumbs>
);

export default IotVisionBreadcrumbs;
